import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ActionButtons;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { IconButton } from '@instructure/ui-buttons';
import { IconEditLine, IconTrashLine, IconDuplicateLine } from '@instructure/ui-icons';
import { jsx, Global } from '@instructure/emotion';
import DragHandle from '../../../../common/components/shared/drag_and_drop/DragHandle';
import makeScrollable from '../../../../common/components/shared/functionality/makeScrollable';
import noop from '../../../../common/util/noop';
import { EDIT, REMOVE, COPY, END_EDITING_TRIGGER_CLASSNAME, withStyleOverrides } from '@instructure/quiz-common';
import generateStyle from './styles';
import generateComponentTheme from './theme';
var ScrollTargetButton = makeScrollable(IconButton);
export var ActionButtons = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ActionButtons = /*#__PURE__*/function (_Component) {
  function ActionButtons() {
    var _this2;
    _classCallCheck(this, ActionButtons);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ActionButtons, [].concat(args));
    _defineProperty(_this2, "editButton", null);
    _defineProperty(_this2, "connectDragSource", function (dragHandle) {
      if (_this2.props.shouldDisableDragHandle) {
        return dragHandle;
      }
      return _this2.props.connectDragSource(dragHandle);
    });
    _defineProperty(_this2, "onButtonFocus", function (e) {
      e.stopPropagation();
    });
    _defineProperty(_this2, "switchOnEditing", function () {
      _this2.props.switchOnEditing();
    });
    _defineProperty(_this2, "setEditRef", function (node) {
      _this2.editButton = node;
    });
    return _this2;
  }
  _inherits(ActionButtons, _Component);
  return _createClass(ActionButtons, [{
    key: "shouldFocusOnMount",
    value: function shouldFocusOnMount() {
      return this.props.shouldFocusOnMount && !this.props.editingAddContentPopover;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      if (this.shouldFocusOnMount() && this.editButton) {
        // use setTimeout to break away from RCE destruction that loses focus
        setTimeout(function () {
          _this3.editButton && _this3.editButton.getWrappedInstance().setFocus();
        }, 50);
      }
      this.props.makeStyles();
    }
  }, {
    key: "render",
    value: function render() {
      var hideClass = !this.props.shouldRenderEdit ? 'hide' : '';
      var parentDivClass = "buttons ".concat(END_EDITING_TRIGGER_CLASSNAME);
      return jsx("div", {
        className: parentDivClass,
        tabIndex: "-1",
        onFocus: this.onButtonFocus,
        css: this.props.styles.buttons
      }, jsx(Global, {
        styles: this.props.styles.globalStyles
      }), jsx("div", {
        className: hideClass,
        css: this.props.styles.edit
      }, jsx(ScrollTargetButton, {
        as: "div",
        onClick: this.switchOnEditing,
        scrollKey: this.props.scrollKey,
        size: "small",
        withBackground: false,
        withBorder: false,
        renderIcon: IconEditLine,
        "data-automation": "sdk-edit-question-button",
        shouldFocusOnMount: this.shouldFocusOnMount(),
        screenReaderLabel: this.props.quizEntry.generateScreenReaderText(this.props.displayPosition, EDIT),
        ref: this.setEditRef
      })), this.props.questionCopyEnabled && this.props.onCopy && jsx(IconButton, {
        as: "div",
        onClick: this.props.onCopy,
        disabled: this.props.shouldDisableCopy,
        renderIcon: IconDuplicateLine,
        withBackground: false,
        withBorder: false,
        size: "small",
        "data-automation": "sdk-copy-question-button",
        screenReaderLabel: this.props.quizEntry.generateScreenReaderText(this.props.displayPosition, COPY)
      }), this.connectDragSource(jsx("div", null, jsx(DragHandle, {
        displayPosition: this.props.displayPosition,
        quizEntry: this.props.quizEntry,
        quizEntries: this.props.quizEntries,
        disabled: this.props.shouldDisableDragHandle
      }))), this.props.shouldRenderDelete && jsx(IconButton, {
        as: "div",
        onClick: this.props.onDelete,
        disabled: this.props.shouldDisableDeleteButton,
        renderIcon: IconTrashLine,
        withBackground: false,
        withBorder: false,
        size: "small",
        "data-automation": "sdk-delete-question-button",
        screenReaderLabel: this.props.quizEntry.generateScreenReaderText(this.props.displayPosition, REMOVE)
      }));
    }
  }]);
}(Component), _defineProperty(_ActionButtons, "displayName", 'BuildingActionButtons'), _defineProperty(_ActionButtons, "componentId", "Quizzes".concat(_ActionButtons.displayName)), _defineProperty(_ActionButtons, "propTypes", {
  connectDragSource: PropTypes.func.isRequired,
  displayPosition: PropTypes.number.isRequired,
  editingAddContentPopover: PropTypes.bool.isRequired,
  onCopy: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
  questionCopyEnabled: PropTypes.bool.isRequired,
  quizEntries: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  quizEntry: ImmutablePropTypes.record.isRequired,
  scrollKey: PropTypes.string,
  shouldDisableCopy: PropTypes.bool,
  shouldDisableDragHandle: PropTypes.bool,
  shouldDisableDeleteButton: PropTypes.bool,
  shouldRenderEdit: PropTypes.bool,
  shouldRenderDelete: PropTypes.bool,
  switchOnEditing: PropTypes.func,
  shouldFocusOnMount: PropTypes.bool,
  styles: PropTypes.object,
  makeStyles: PropTypes.func
}), _defineProperty(_ActionButtons, "defaultProps", {
  onCopy: null,
  scrollKey: void 0,
  shouldDisableCopy: false,
  shouldDisableDragHandle: false,
  shouldDisableDeleteButton: false,
  shouldRenderDelete: true,
  shouldRenderEdit: true,
  switchOnEditing: noop,
  shouldFocusOnMount: false
}), _ActionButtons)) || _class);
export default ActionButtons;